import React from 'react';

const steps = [
  ['01', 'Look at the setup', 'Website, email, hosting, domains, and who is responsible for each piece.'],
  ['02', 'Name the priority', 'What is urgent, what can wait, and what is just extra vendors.'],
  ['03', 'Do the work', 'A project, a monthly plan, or both. Then it is documented.']
];

const ServicesHowItWorks = () => {
  return (
    <section className="bg-[#FAF8F3] py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <h2 className="max-w-xl text-4xl leading-tight sm:text-5xl">
          We start with what is happening, not a package.
        </h2>
        <div className="mt-14 grid gap-10 md:grid-cols-3">
          {steps.map(([number, title, text]) => (
            <div key={number} className="border-t border-[#174C3C] pt-6">
              <div className="text-xs font-bold uppercase tracking-[0.2em] text-[#D7B77A]">
                {number}
              </div>
              <h3 className="mt-4 text-2xl leading-tight">{title}</h3>
              <p className="mt-4 text-lg leading-relaxed text-[#17211E]/70">{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesHowItWorks;
